import { render, staticRenderFns } from "./wty-radio.vue?vue&type=template&id=73b5af0e&scoped=true&"
import script from "./wty-radio.vue?vue&type=script&lang=js&"
export * from "./wty-radio.vue?vue&type=script&lang=js&"
import style0 from "./wty-radio.vue?vue&type=style&index=0&id=73b5af0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5af0e",
  null
  
)

export default component.exports